import {EnvironmentProviders, ErrorHandler, inject, Injectable, Provider, provideAppInitializer} from '@angular/core';
import * as Sentry from "@sentry/angular";
import {Router} from "@angular/router";
import {ILogger} from "@mindpath/shared";
import {GlobalErrorHandler} from "./global-error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class SentryService implements ILogger {

  debug(...data: unknown[]) {
    Sentry.captureMessage(data.join(' '), 'debug');
  }
  trace = this.debug;
  log(...data: unknown[]) {
    Sentry.captureMessage(data.join(' '), 'log');
  }
  info(...data: unknown[]) {
    Sentry.captureMessage(data.join(' '), 'info');
  }
  warn(...data: unknown[]) {
    Sentry.captureMessage(data.join(' '), 'warning');
  }
  error(...data: unknown[]) {
    Sentry.captureMessage(data.join(' '), 'error');
  }
  critical(...data: unknown[]) {
    Sentry.captureMessage(data.join(' '), 'fatal');
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  group(...data: unknown[]) {}
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  groupCollapsed(...data: unknown[]) {};
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  groupEnd(...data: unknown[]){ }

  public static provideTracking(): (Provider | EnvironmentProviders)[] {
    return [
      {
        provide: ErrorHandler,
        useExisting: GlobalErrorHandler,
      },
      {
        provide: Sentry.TraceService,
        deps: [Router],
      },
      // Constructing TraceService is the whole point — that is what wires Sentry's
      // router instrumentation. The old form said so with an empty useFactory and
      // deps: [TraceService]; inject() says it directly.
      provideAppInitializer(() => {
        inject(Sentry.TraceService);
      })
    ]
  }
}
